import { Col, Container, Row } from 'react-bootstrap';
import { SimpleAncer } from '../../../Components/button';
import LayoutWithoutFooter from '../../../layouts/layoutWithoutFooter/LayoutWithoutFooter';
import {
  SectionHeadingLarge,
  HeadingDesc,
  SectionInnerHeading
} from '../../../Components/Headings';
import docImg from '../../../assets/images/png/faetured-doctor.png';
import halfHeart from '../../../assets/images/png/half-heart.png';
import './paymentConfimation.css';

function PaymentConfimation() {
  return (
    <LayoutWithoutFooter>
      <section className="paymentConfimation">
        <Container>
          <Row>
            <Col md={5}>
              <div className="leftBox">
                <SectionHeadingLarge text="Your Appointment is confirmed!" />
                <HeadingDesc text="Here are the details. You can edit any information from the user account area." />
                <div className="btnsContainer">
                  <SimpleAncer text="LET’S START" />
                  <SimpleAncer text="ADD TO CALNEDAR" />
                </div>
              </div>
            </Col>
            <Col md={4} className="offset-lg-1">
              <div className="rightBox">
                <div className="imgBox">
                  <img src={docImg} alt="docImg" />
                </div>
                <SectionInnerHeading text="Dr. Madeeha Asad" />
                <HeadingDesc text="Tomorrow, Apr 7 - 9:45 am" />
                <div className="available">
                  <HeadingDesc text="Video Consultation" />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        <img src={halfHeart} alt="halfHeart" className="halfHeart" />
      </section>
    </LayoutWithoutFooter>
  );
}

export default PaymentConfimation;
